import kebabCase from 'lodash/kebabCase.js'

import {
  PRODUCT_DETAIL_KITTING_PANEL,
  PRODUCT_SINGLE_URI_COMPONENT,
} from '../../../../common/constants/Products.js'

import {
  preferCartOrderLineNamesSelector,
  usesInventorySelector,
  useInventoryAllocationSelector,
} from '../../../../data/company.js'
import {
  getOrderLineShippabilityHint,
  orderLineAllocationHintSelector,
  orderLineIsDropshipHintSelector,
} from '../../../../data/orders.js'
import {isDigitalSelector, isKitSelector} from '../../../../data/products.js'
import {hasProductPermissionSelector} from '../../../../data/me.js'

import Icon from '../../../../common/icons/Icon.js'
import LineAllocationIcon from '../../Fields/LineAllocationIcon.js'
import LinkButton from '../../../../common/components/Link/LinkButton.js'
import Quantity from '../../../../common/components/Quantity.js'
import {useSelector} from '../../../../store.js'
import className from '../../../../common/className.js'

function LineDetails({line}) {
  const {sku} = line
  const preferCartOrderLineNames = useSelector(preferCartOrderLineNamesSelector)
  const hasProductPermission = useSelector(hasProductPermissionSelector)
  const isKit = useSelector((state) => isKitSelector(state, {sku}))
  const isDigital = useSelector((state) => isDigitalSelector(state, {sku}))

  const details = (
    <div>
      <strong className="block">
        {preferCartOrderLineNames && line.order_line_product_name
          ? line.order_line_product_name
          : line.product_name}
      </strong>
      <span className="unbold block">{sku}</span>
      {line.details && <em className="block">{line.details}</em>}
    </div>
  )

  return (
    <div>
      {hasProductPermission ? (
        <a
          className="link--line-detail inline-block"
          href={`#/${PRODUCT_SINGLE_URI_COMPONENT}/${encodeURIComponent(sku)}`}
        >
          {details}
        </a>
      ) : (
        details
      )}
      {(isKit || isDigital) && (
        <div className="margin-top-3">
          {isDigital && (
            <strong
              title="Digital"
              className="label__callout label__callout--grey no-underline margin-right-5"
            >
              D
            </strong>
          )}
          {isKit &&
            (hasProductPermission ? (
              <LinkButton
                className="label__callout label__callout--grey no-underline"
                href={`#/${PRODUCT_SINGLE_URI_COMPONENT}/${encodeURIComponent(
                  sku,
                )}/${PRODUCT_DETAIL_KITTING_PANEL}`}
              >
                <strong>KIT</strong>
              </LinkButton>
            ) : (
              <strong className="label__callout label__callout--grey no-underline">
                KIT
              </strong>
            ))}
        </div>
      )}
    </div>
  )
}

export default function Line({orderNumber, line}) {
  const usesInventory = useSelector(usesInventorySelector)
  const shippabilityHint = useSelector((state) =>
    getOrderLineShippabilityHint(state, line),
  )
  const allocationHint = useSelector((state) =>
    orderLineAllocationHintSelector(state, {
      orderNumber: orderNumber,
      orderLineID: line.id,
    }),
  )
  const isDropshipHint = useSelector((state) =>
    orderLineIsDropshipHintSelector(state, {
      orderNumber: orderNumber,
      orderLineID: line.id,
    }),
  )
  const useInventoryAllocation = useSelector(useInventoryAllocationSelector)

  return (
    <li
      className={className`list__item--line ${{
        [kebabCase(line.shippability.shippability)]:
          usesInventory && !useInventoryAllocation,
        [kebabCase(line.line_allocation_status)]: useInventoryAllocation,
        dropshippable: line.shippability.is_dropship && !useInventoryAllocation,
      }}`}
    >
      <dl className="list--line-details flex--justify-nowrap">
        <dt className="list__title--line-detail flex">
          {useInventoryAllocation && (
            <LineAllocationIcon
              allocationStatus={line.line_allocation_status}
              allocationHint={allocationHint}
              isDropship={line.shippability.is_dropship}
              isDropshipHint={isDropshipHint}
              className="inline-block fs-n0 margin-right-3 compact"
            />
          )}
          {usesInventory && !useInventoryAllocation && (
            <div
              className="list__item--line-detail inline-block tooltip--top"
              data-hint={shippabilityHint}
            >
              <Icon
                name={
                  line.shippability.is_dropship
                    ? 'truck'
                    : line.shippability.shippability === 'shippable'
                      ? 'check-circle'
                      : line.shippability.shippability === 'partially_shippable'
                        ? 'exclamation-triangle'
                        : line.shippability.shippability === 'shipped'
                          ? 'cube'
                          : 'ban'
                }
                className="fs-n1"
              />
            </div>
          )}
          <LineDetails line={line} />
        </dt>
        <dd className="list__item--line-detail list__item--line-qty flex-shrink-0">
          <strong>
            <Quantity value={line.quantity} />
          </strong>
        </dd>
      </dl>
    </li>
  )
}
